import { app } from "../../feathers";
import { TranslateJSON } from "Js/bfUtilities";
// import { actions } from "Js/actionsProcessor";
import { cacheRegListeners, cacheAppLoad } from "Js/cacher.js"

// import _ from "lodash";
// import VueRouter from "vue-router";

import { Injector } from "Js/injector";

var injector = new Injector({
  container: document.getElementsByTagName("head")[0]
});

export default {
  state: {
    loaded: false,
    theme: "theme-green-full",
    showProfile: false,
    sidebarOpen: false,
    sidebarMini: false,
    showSideNavBar: false,
    showTopNavBar: true,
    showTopNavBarNoAuth: false,
    showSideNavBarNoAuth: false,
    errors: [],
    components:[],
    app: {},
    params: {},
    content: { 
      app: {},
      appCaching: [] },
    pendingThreads: [],
    isOnline: false
  },

  actions: {
    LOAD_SITE_MODEL: ({ commit, state, dispatch }) => {
      dispatch('ACTIONS_PAUSE', true);
      return new Promise(async (resolve, reject) => {
        var bfops = JSON.parse(window.localStorage.getItem('_bfsite'));
        var hash = bfops && bfops.siteJSON && bfops.siteJSON.hash || '';
        
        var attempts = 20;
        for (let i = 0; i < attempts ; i++) {
            await timer(100);
            if (state.isOnline) break;
        }
        if (bfops) {
          var site = await domHeaderInsertions(resolve, reject, bfops);
          loadSite ({resolve, reject, commit, dispatch}, site);
        }
        
        if (state.isOnline) {
          loadSiteFromNetwork(resolve, reject, hash);
        }
      });
    },

    ERROR_PUSH: ({ commit, state, dispatch }, errObj) => {
      commit("setError", errObj);
      return;
    },

    ERROR_CLEAR: ({ commit, state, dispatch }) => {
      commit("clearError");
      return;
    }
  },

  getters: {
    showTopNavBar: (state, getters, rootState, rootGetters) => {
      return state.showTopNavBar && (state.showTopNavBarNoAuth || rootState.auth.authenticated)
    },

    showSideNavBar: (state, getters, rootState, rootGetters) => {
      return state.showSideNavBar && (state.showSideNavBarNoAuth || rootState.auth.authenticated)
    },
    
    components: (state, getters, rootState, rootGetters) => name => {
      return _.find(state.content.components, { 'name': name }) || _.find(state.components, { 'name': name }); 
    },
    
    pendingThreads: (state, getters, rootState, rootGetters) => {
      return state.pendingThreads; 
    },
    
    isOnline: (state, getters, rootState, rootGetters) => name => {
      return state.isOnline;
    },
    
    getForm: (state, getters, rootState, rootGetters) => id => {
      return false;
    }
  },

  mutations: {
    setError: (state, errObj) => {
      state.errors.unshift(errObj);
    },

    clearError: (state) => {
      state.errors = []
    },

    SET_APP: (state, appObject) => {
      state.content.app = Object.assign({}, state.content.app, appObject);
    },

    SET_PARAMS: (state, paramsObject) => {
      state.content.params = Object.assign({},
        state.content.params,
        paramsObject
      );
    },

    SET_SITE: (state, site) => {
      let newObj = Object.assign({}, state, site);
      newObj.loaded = true;
      Vue.set(vueapp.$store.state, "site", newObj); // because reactivity breaks
      
    },

    SET_SIDEBAROPEN(state, mode) {
      state.sidebarOpen = mode;
    },

    SET_SIDEBARMINI(state, mode) {
      state.sidebarMini = mode;
    },

    SET_PENDINGTRHEADS: (state, idThread) => {
      state.pendingThreads.length ?
        state.pendingThreads.push(idThread) :
        state.pendingThreads[0] = idThread;
    },
    
    CLEAR_PENDINGTHREADS: (state) => {
      state.pendingThreads = [];
    },
    
    SET_ISONLINE(state, status) {
      console.log('BF App (SET_ISONLINE)  status:', status)
      if (state.isOnline !== status && status) {
        window.vueapp.$store.dispatch('ACTIONS_QUEUE', {actions: [{"action": "namedAction","name": "appIsOnline"}]})
      }
      else if (state.isOnline !== status && !status) {
        window.vueapp.$store.dispatch('ACTIONS_QUEUE', {actions: [{"action": "namedAction","name": "appIsOffline"}]})
      }
      
      state.isOnline = status;
    },
    
    loadSiteFromNetwork
  }
};

function domHeaderInsertions (resolve, reject, result) {
  //TODO add error testing here
  if (result.statusLS) {
    result = JSON.parse(window.localStorage.getItem('_bfsite'));
  }
  else {
    window.localStorage.setItem('_bfsite', JSON.stringify(result));
  }
  
  if (!result.siteJSON.id) {
    reject("No site record found for this domain");
  }
  //TRANSLATE
  var site = result.siteJSON;
  TranslateJSON(site, 0); //site uses parent wndw[0] for calcs

  // DOM INSERTIONS SYNC
  if (_.get(site, "content.headerInsertions")) {
    return new Promise((resolve, reject) => {
        injector.oncomplete = function() {
          resolve(site)
        };
        injector.insert(site.content.headerInsertions);
      })
      .then(site => {
        injector.oncomplete = function(){};
        return site
      })
  }
  else {
    return site
  }
}

function loadSite ({resolve, reject, commit, dispatch}, site) {
    // DOM INSERTIONS ASYNC
    if (_.get(site, "content.headerInsertionsDefer")) {
      injector.insert(site.content.headerInsertionsDefer);
    }
    
    // CSS
    if (site.css) {
      var style = document.createElement("style");
      style.appendChild(document.createTextNode(site.css));
      document.head.appendChild(style);
    }
    
    commit("SET_SITE", site);
    
    cacheRegListeners() // cahcing after model is mutated
    
    //ACTIONS
    if (_.get(site, "content.namedActions.onAppLoad") && BF.getQueryParam('_onAppLoad')!=='0' ) {
      dispatch('ACTIONS_QUEUE', site.content.namedActions.onAppLoad);
    }
  
    // need to wait for actions to finish running
  
    //Hydrate any cachable app keys
    cacheAppLoad()
    resolve(site);
}

function timer(ms)  {return new Promise(res => setTimeout(res, ms)); }

async function loadSiteFromNetwork (resolve, reject, hash) {
  app
  .service("/site")
  .find({
    query: {
      active: 1,
      hashLS: hash
    }
  })
  .then(async result => {
//TODO add error testing here
        if (!result.statusLS) {
          //Save error page locally everytime _bfsite is saved on LS
          var errorForm = await app.service("forms").get('FR_errorpage');
          _.set(result.siteJSON.content.layouts, 'error.formSchema', errorForm)
          window.localStorage.setItem('_bfsite', JSON.stringify(result));
          window.location.reload();
        }
        resolve();
    }
  )
  .catch(error => {
    console.log("@Store.site - siteLoad_Error", error);
    reject(error);
  });
}